// 网络请求 - 二次封装
import axios from 'axios';

const service = axios.create({
    baseURL: "https://webapi.yuanbaijia.com",
    timeout: 5000,
});
// 请求拦截器
service.interceptors.request.use(
    config => {
        // 发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
        // 判断请求的数据类型，设置对应的请求头
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        } else if (typeof config.data === 'object') {
            
            // config.data = json.stringify(config.data); //数据转化,也可以使用qs转换
            // config.headers['Content-Type'] = 'application/json;charset=utf-8';
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        } else {
            config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
            config.headers['Content-Type'] = 'application/json;charset=utf-8';
        }
        //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
        //    const token = getCookie('名称');//这里取token之前，你肯定需要先拿到token,存一下
        //    if(token){
        //       config.params = {'token':token} //如果要求携带在参数中
        //       config.headers.token= token; //如果要求携带在请求头中
        //     }
        return config;
    },
    error => {
        Promise.reject(error)
    }
);
// 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if(response.data.state === "error"){
                return Promise.reject(response.data.message);
            }
            return response.data;
        } else {
            return Promise.reject(response.data.message);
        }
    },
    error => {
        const res = error.response;
        if (res && res.data && res.data.state === "error") {
            return Promise.reject(res.data.message);
        } else {
            return Promise.reject(error.message);
        }
    }
);
export default service;